import axios from 'axios';
// import { API_BASE_URL } from './common/constants';
import { logout } from './Redux/AuthSlice';
import { notification } from 'antd';
import store from './Redux/store';
import Cookies from 'js-cookie';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;


const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor to Attach Token in Headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('authToken');
    if (token) {
      config.headers['token'] = token; 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle Expired Token
axiosInstance.interceptors.response.use(
  (response) => {
    // Check if response contains { status_code: 401 } inside body
    if (response.data?.status_code === 401) {
      // Remove token from localStorage
      Cookies.remove('authToken');
      Cookies.remove('isLoggedIn');
   

      // Dispatch logout action
      store.dispatch(logout());

      // Show a notification to the user
      notification.error({
        message: "Session Expired",
        description: "Your session has expired. Please log in again.",
        duration: 1,
      });

      // Reject the response to stop further execution
      return Promise.reject(new Error("Session expired. Please log in again."));
    }
    
    return response;
  },
  (error) => {
      if (error.response?.status === 401 ) {

        Cookies.remove('authToken');
        Cookies.remove('isLoggedIn');
  
        // Dispatch logout action
        store.dispatch(logout());
  
        // Show a notification to the user
        notification.error({
          message: "Session Expired",
          description: "Your session has expired. Please log in again.",
          duration: 1,
        });
        return Promise.reject(new Error("Session expired. Please log in again."));
      }
  
      return Promise.reject(error);
  }
);

export default axiosInstance;
